module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chaptitle"
  }, [_c('a', {
    attrs: {
      "id": "con"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/06_preface#pre"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/07_introduction#intro"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": ".5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/09_chapter01#c1"
    }
  }, [_vm._v("1. The Enchanted World")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/10_chapter02#c2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. The Rose and Thorn Path")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/11_chapter03#c3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Tools of the Witches' Craft")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/12_chapter04#c4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Plant Spirits of the Greenwood")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/13_chapter05#c5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Works of Magic")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/14_chapter06#c6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. The Old Ones")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/15_chapter07#c7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. The Mythos")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/16_chapter08#c8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. The Old Rites")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/17_chapter09#c9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. The Modern Solitary Rites")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": ".5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/18_appendixa#appa",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix A: The Plant Spirit Seals")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/19_appendixb#appb",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix B: Symbols of the Rose and Thorn Path")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/20_bibliography#bib",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-350067dc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/05_contents.vue
// module id = 69
// module chunks = 0